<app-progress-bar-overlay></app-progress-bar-overlay>
<div class="contenitore" style="padding-bottom: 15px !important">
  <div class="titolo-pagina">
    <app-titolo-subtitolo titolo="Gestione documenti"></app-titolo-subtitolo>
    <div class="sotto-titolo">
      In questa sezione è possibile caricare documenti che diventeranno la base di conoscenza della
      tua azienda per l’Intelligenza artificiale.<br />
      Attraverso i documenti che saranno caricati in questa sezione, la IA acquisirà le conoscenze
      relative alle attività della tua azienda e potrà suggerirti le risposte alle richieste
      informative a cui dovrai rispondere durante i percorsi guidati di sostenibile.cloud.<br />
      I documenti che possono essere caricati sono di tipo PDF, tra i più comuni possono essere:
      Visura camerale, informativa 231, regolamenti, che contengono informazioni su certificazioni,
      politiche, processi o verbali del CDA. Per avere una lista più esaustiva clicca
      <a (click)="apriListaEsaustiva()" class="link-cliccabile">qui</a>.
    </div>
  </div>
  <div class="cnt-documenti">
    @if (showError) {
      <div class="msg-error">{{ errorCaricamento }}</div>
    } @else {
      <!-- BOTTONI AZIONE SULLA CARTELLA -->
      <ng-container [ngTemplateOutlet]="btnAzioni"></ng-container>

      <div class="cnt-tree-and-lista-file">
        <!-- SINISTRA :  Folder Tree -->
        <div class="tree-cmp">
          <app-folder-tree></app-folder-tree>
          <div>
            <app-storage-chart [tipoGrafico]="'bar'"></app-storage-chart>
          </div>
        </div>

        <div class="tab-container">
          <div class="tab">
            <app-breadcrumb-folder-tree></app-breadcrumb-folder-tree>
          </div>

          <div class="body">
            <app-lista-file-bucket></app-lista-file-bucket>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<ng-template #btnAzioni>
  <div class="button-container">
    <button matButton="outlined" class="btn-azione" (click)="onNewFolder(true)">
      <mat-icon>create_new_folder</mat-icon>
      Nuova cartella
    </button>
    @if (folderSelezionato && !folderSelezionato.locked) {
      <button class="btn-azione" (click)="onNewFolder(false)">
        <mat-icon>edit</mat-icon>
        Rinomina Cartella
      </button>
      <button class="btn-azione" (click)="fileInput.click()">
        <mat-icon>cloud_upload</mat-icon>
        Carica Documento
        <!-- Input file nascosto -->
        <input
          #fileInput
          type="file"
          multiple
          hidden
          (change)="onUploadFile($any($event.target)?.files)"
          (click)="$any($event.target).value = null"
        />
      </button>
    }
    <button class="btn-azione" (click)="onInfoFileFolder()">
      <mat-icon>info</mat-icon>
      Dettagli cartella
    </button>
    @if (folderSelezionato && !folderSelezionato.locked) {
      <button class="btn-azione" (click)="onDeleteFolder()">
        <mat-icon class="delete">delete</mat-icon>
        Elimina cartella
      </button>
    }
  </div>
</ng-template>
